import { createRootRoute, Outlet } from "@tanstack/react-router"
import { z } from "zod"

import { NotFound } from "@/sections/errors/NotFound"
import { RouterDevtools } from "@/utils/devtools"

export const Route = createRootRoute({
  validateSearch: z.object({ captureOpen: z.boolean().nullish() }),
  notFoundComponent: NotFound,
  component: RootRoute,
})

function RootRoute() {
  return (
    <>
      <div className="font-ic-body container mx-auto flex min-h-dvh max-w-3xl flex-col justify-between landscape:max-w-7xl">
        <Outlet />
      </div>

      <RouterDevtools />
    </>
  )
}
